module.exports = "fragment Category on Category {\n  id\n  title\n  sortOrder\n  features {\n    ...FeatureFragment\n  }\n}\n"